export enum ORDER_BY_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}
